import envConfig from '../envConfig'
import { getAppUrl, getVersionUrl } from '../helpers/microApps/buildUrls'
import PermissionsUtil from '../helpers/permissions/PermissionsUtil'
import { combinePathsWithEnvAndContext } from '../helpers/routeUtil'
import Locations from '../helpers/tools/locations'
import { MicroApp } from '../types/microApp'
import { OPERATORS_PROVIDERS_PREFIX } from '../constants/common'
import { NONE } from '../redux/app/types'

const { permissions } = PermissionsUtil

const microAppUrl = envConfig.apps.treasuryAnalytics

const App: MicroApp = {
  name: 'treasury_analytics',
  importFunction: async (version: string) => (
    System.import(getAppUrl(microAppUrl, version))
  ),
  getVersion: async (): Promise<string> => {
    const version = await System.import(getVersionUrl(microAppUrl))
    return version.default
  },
  permissionsCheck: () => {
    const requiredPrefixes = [
      OPERATORS_PROVIDERS_PREFIX,
      permissions.operations.payouts.search()
    ]
    return requiredPrefixes.every(prefix => PermissionsUtil.findPermissionsByPrefix(prefix,
      PermissionsUtil.masqueraderRoles).length)
  },
  paths: combinePathsWithEnvAndContext([
    { path: Locations.treasuryAnalyticsPage, userTypeContext: NONE }
  ])
}

export default App
